import { useEffect, useLayoutEffect, useRef } from "react"

export const useIntersectionObserver = (
  selector: string | null,
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit
) => {
  const cb = useRef(callback)

  useLayoutEffect(() => {
    cb.current = callback
  }, [callback])

  useEffect(() => {
    if (typeof selector !== "string") return

    const sentinel = document.querySelector(selector)

    if (!sentinel) return

    const observer = new IntersectionObserver(cb.current, options)

    observer.observe(sentinel)

    return () => {
      observer.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selector])
}
